import { createApp } from 'vue';
import App from "./App.vue";
import './registerServiceWorker'

const app = createApp(App);

document.addEventListener('DOMContentLoaded', () => {
    app.mount("#neuvotteluhuoneen_varusteopas");
})